import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useUserContext } from "../../context/userContext";
import logo from "../../assets/tweezers.svg";

const Preloader = () => {
  const { loading, setLoading } = useUserContext();

  useEffect(() => {
    const imageElements = document.querySelectorAll("img");
    const imageSources = Array.from(imageElements).map(img => img.src);
    
    const preloadImages = async () => {
      await Promise.all(
        imageSources.map((src) => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = src;
            img.onload = resolve;
            img.onerror = resolve;
          });
        })
      );
      setLoading(false);
    };
    
    preloadImages();
  }, [setLoading]);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          className="fixed inset-0 flex items-center justify-center bg-secondary z-50"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex flex-col items-center space-y-4">
            <img src={logo} alt="Logo" className="animate-pulse" />
            <div className="w-14 h-14 mt-14 border-4 border-gray-200 border-t-transparent border-l-green-500 rounded-full animate-spin"></div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
